import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItemTitle } from '@forzoom/item-form';
import SingleUploader from '@/components/uploader/singleUploader.vue';
import store from '@/store';

var ItemTwoUploader =
/** @class */
function (_super) {
  __extends(ItemTwoUploader, _super);

  function ItemTwoUploader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 可能存在判断出错的情况 */


    _this.hasUploaded = {};
    return _this;
  }
  /**
   * 添加二维码
   */


  ItemTwoUploader.prototype.onAdd = function (index, imageInfo) {
    if (this.autoUpload) {
      this.upload(index, imageInfo);
    } else {
      this.$emit('input', imageInfo);
    }
  };
  /**
   * 删除二维码
   */


  ItemTwoUploader.prototype.onRemove = function (index) {
    if (!this.value) {
      this.$emit('input', []);
    }

    this.$set(this.value, index, null);
    this.$emit('input', this.value);
    this.$set(this.hasUploaded, index, false);
  };

  ItemTwoUploader.prototype.onLoad = function () {
    store.commit('startRequest');
  };

  ItemTwoUploader.prototype.onFinish = function () {
    store.commit('endRequest');
  };
  /**
   * 上传流程
   */


  ItemTwoUploader.prototype.upload = function (index, image) {
    return __awaiter(this, void 0, void 0, function () {
      var result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            image = image || (this.value || [])[index];

            if (this.hasUploaded[index] || !image) {
              return [2
              /*return*/
              ];
            }

            store.commit('startRequest');
            return [4
            /*yield*/
            , this.httpRequest(index, image)];

          case 1:
            result = _a.sent();
            store.commit('endRequest');

            if (!this.value) {
              this.$emit('input', []);
            }

            this.$set(this.value, index, result);
            this.$emit('input', this.value);
            this.$set(this.hasUploaded, index, true);
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 生命周期
   */


  ItemTwoUploader.prototype.beforeSubmit = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.upload(0);
        this.upload(1);
        return [2
        /*return*/
        ];
      });
    });
  };

  ItemTwoUploader.prototype.mounted = function () {
    if (this.value) {
      if (this.value[0]) {
        // @ts-ignore
        this.$refs.group.setImage(this.value[0].url);
        this.hasUploaded[0] = true;
      }

      if (this.value[1]) {
        // @ts-ignore
        this.$refs.monitor.setImage(this.value[1].url);
        this.hasUploaded[1] = true;
      }
    }
  };

  __decorate([Prop({
    type: String,
    "default": 'wechat'
  })], ItemTwoUploader.prototype, "mode", void 0);

  __decorate([Prop({})], ItemTwoUploader.prototype, "value", void 0);

  __decorate([Prop({})], ItemTwoUploader.prototype, "title", void 0);

  __decorate([Prop({})], ItemTwoUploader.prototype, "titleHint", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], ItemTwoUploader.prototype, "uploadHint", void 0);

  __decorate([Prop({
    required: true,
    type: Function
  })], ItemTwoUploader.prototype, "httpRequest", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], ItemTwoUploader.prototype, "autoUpload", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], ItemTwoUploader.prototype, "isValiate", void 0);

  ItemTwoUploader = __decorate([Component({
    name: 'ItemTwoUploader',
    components: {
      ItemTitle: ItemTitle,
      SingleUploader: SingleUploader
    }
  })], ItemTwoUploader);
  return ItemTwoUploader;
}(Vue);

export default ItemTwoUploader;